import React, { createContext, useContext } from 'react';
import { refId, sectionId } from '../../content/whitepaper';

// Where cross-references point: '' on /whitepaper/, '/whitepaper/' when the
// paper is quoted on other pages.
export const PaperBase = createContext('');

const TOKENS = /(\*\*.+?\*\*)|((?:\[\d+\])+)|(Sections? \d+(?: and \d+)?)|(https?:\/\/\S+)/g;

// The source keeps the PDF's straight quotes; display uses typographic ones.
export function smart(text) {
  return text
    .replace(/(^|[\s([\u2014\u2013-])"/g, '$1\u201C')
    .replace(/"/g, '\u201D')
    .replace(/'/g, '\u2019');
}

function Cites({ raw, base }) {
  const numbers = raw.match(/\d+/g);
  return numbers.map((n) => (
    <a key={n} className="pp-cite" href={`${base}#${refId(n)}`} aria-label={`Reference ${n}`}>
      [{n}]
    </a>
  ));
}

function SectionRefs({ raw, base }) {
  const [, word, first, second] = raw.match(/^(Sections?) (\d+)(?: and (\d+))?$/);
  const link = (n) => (
    <a className="pp-xref" href={`${base}#${sectionId(n)}`}>
      {n}
    </a>
  );
  return (
    <>
      {word} {link(first)}
      {second ? <> and {link(second)}</> : null}
    </>
  );
}

function render(text, base) {
  const out = [];
  let last = 0;
  let key = 0;
  TOKENS.lastIndex = 0;
  let match = TOKENS.exec(text);
  while (match) {
    if (match.index > last) out.push(smart(text.slice(last, match.index)));
    const [whole, bold, cites, sections, url] = match;
    if (bold) {
      out.push(<strong key={key}>{render(bold.slice(2, -2), base)}</strong>);
    } else if (cites) {
      out.push(<Cites key={key} raw={cites} base={base} />);
    } else if (sections) {
      out.push(<SectionRefs key={key} raw={sections} base={base} />);
    } else if (url) {
      out.push(
        <a key={key} className="pp-url" href={url} target="_blank" rel="noreferrer">
          {url}
        </a>,
      );
    }
    key += 1;
    last = match.index + whole.length;
    TOKENS.lastIndex = last;
    match = TOKENS.exec(text);
  }
  if (last < text.length) out.push(smart(text.slice(last)));
  return out;
}

export default function Rich({ text }) {
  const base = useContext(PaperBase);
  return <>{render(text, base)}</>;
}

// Plain text with the markup removed, for meta tags and aria labels.
export function plain(text) {
  return smart(text.replace(/\*\*/g, '').replace(/\[\d+\]/g, '').replace(/\s{2,}/g, ' ').trim());
}
